/**
 * Reusable JSON-LD schema builders for TRITAL Care® pages.
 * Pass any of these (or arrays of them) to <PageMeta schema={...} />.
 */

const SITE_ROOT = "https://www.tritalcare.com";

/* ------------ LocalBusiness — used on /contact and /about ------------- */
export const LOCAL_BUSINESS_SCHEMAS = [
  {
    "@context": "https://schema.org",
    "@type": "MedicalBusiness",
    "@id": `${SITE_ROOT}/#office-hq`,
    name: "TRITAL Care® — USA Head Office",
    parentOrganization: { "@id": `${SITE_ROOT}/#organization` },
    address: {
      "@type": "PostalAddress",
      streetAddress: "5423 Pecan Fall PL",
      addressLocality: "Missouri City",
      addressRegion: "TX",
      postalCode: "77459",
      addressCountry: "US",
    },
    telephone: "+1-832-303-6622",
    email: "info@tritalcare.com",
    openingHours: "Mo-Fr 08:00-18:00",
    areaServed: "US",
    url: SITE_ROOT,
  },
  {
    "@context": "https://schema.org",
    "@type": "MedicalBusiness",
    "@id": `${SITE_ROOT}/#office-corporate`,
    name: "TRITAL Care® — USA Corporate",
    parentOrganization: { "@id": `${SITE_ROOT}/#organization` },
    address: {
      "@type": "PostalAddress",
      streetAddress: "11104 West Airport Blvd, Suite 213",
      addressLocality: "Stafford",
      addressRegion: "TX",
      postalCode: "77477",
      addressCountry: "US",
    },
    telephone: "+1-832-303-6622",
    areaServed: "US",
  },
  {
    "@context": "https://schema.org",
    "@type": "Organization",
    "@id": `${SITE_ROOT}/#office-india`,
    name: "TRITAL Care® — India Operations",
    parentOrganization: { "@id": `${SITE_ROOT}/#organization` },
    address: {
      "@type": "PostalAddress",
      streetAddress: "First Floor, A-83, A Block, Sector 63",
      addressLocality: "Noida",
      addressRegion: "UP",
      postalCode: "201309",
      addressCountry: "IN",
    },
  },
];

/* ------------ FAQPage builder ------------- */
export function faqSchema(faqs) {
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((f) => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: { "@type": "Answer", text: f.a },
    })),
  };
}

/* ------------ Service builder ------------- */
export function serviceSchema({ name, description, slug }) {
  return {
    "@context": "https://schema.org",
    "@type": "Service",
    name,
    description,
    serviceType: name,
    provider: { "@id": `${SITE_ROOT}/#organization` },
    areaServed: { "@type": "Country", name: "United States" },
    audience: { "@type": "BusinessAudience", name: "Hospitals & health systems" },
    url: `${SITE_ROOT}/services/${slug}`,
  };
}

/* ------------ CollectionPage builder (checklist hubs) ------------- */
export function collectionSchema({ name, url, count }) {
  return {
    "@context": "https://schema.org",
    "@type": "CollectionPage",
    name,
    url,
    isPartOf: { "@id": `${SITE_ROOT}/#website` },
    mainEntity: {
      "@type": "ItemList",
      numberOfItems: count,
    },
  };
}

export { SITE_ROOT };
